var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.29 15.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ff4405;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.84.75c1.55,1.58.87,3.39.1,5.4-.98,2.57-.86,4.09-.03,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.98.75c1.55,1.58.87,3.39.1,5.4-.98,2.57-.86,4.09-.03,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.11.75c1.55,1.58.87,3.39.1,5.4-.98,2.57-.86,4.09-.03,5.4"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: ".75 11.43 .75 14.4 15.54 14.4 15.54 11.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeating);
export default __webpack_public_path__ + "static/media/icon_heating.2ae5ff938308ff1d2c91b598c0e66119.svg";
export { ForwardRef as ReactComponent };